export default "__VITE_ASSET__B6EqSEv8__"